// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../SubscriptionProductTemplate";
import { WireType, } from "../../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../../runtime/wire/serialize";
import { default as deserialize, } from "../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        subscriptionProductTemplate: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.subscriptionProductTemplate !== undefined)
        result.subscriptionProductTemplate = encodeJson_1(value.subscriptionProductTemplate);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.subscriptionProductTemplate !== undefined)
        result.subscriptionProductTemplate = decodeJson_1(value.subscriptionProductTemplate);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.subscriptionProductTemplate !== undefined) {
        const tsValue = value.subscriptionProductTemplate;
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.subscriptionProductTemplate = value;
    }
    return result;
}
